import React, { useContext, useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  Center,
  Divider,
  ModalHeader,
  ModalFooter,
  Stack,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Text,
  Heading,
  Image,
  HStack,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Illustration from '../../../../images/illustration.svg';
import { AccountContext } from 'components/AccountContext';
import _ from 'lodash';
import { WhatsappIcon } from 'react-share';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function ModalRestricaoSexo(props) {
  const disclosure = props.disclosure;
  const navigate = useNavigate();
  const { user, setPage, setUser, toastInadimplente } = useContext(AccountContext);
  return (
    <>
      <Modal isOpen={disclosure.isOpen} onClose={disclosure.onClose} isCentered>
        <ModalOverlay />
        <ModalContent m={'11%'} borderRadius="0.8em">
          <ModalBody>
            <Center mb={'1em'} mt={'1em'}>
              <Image src={Illustration} />
            </Center>
            <Center>
              <Text fontSize={'16px'} fontWeight={'bold'} color={'#333333'}>
                Atenção!
              </Text>
            </Center>
            <Text fontSize={'14px'} mt={'1em'}>
              Parece que o procedimento que você selecionou não é compatível com o sexo do paciente que será atendido.
            </Text>
            <Text fontSize={'14px'} mt={'1em'}>
              Por favor, verifique se a opção escolhida é adequada ao perfil do paciente.
            </Text>
            <Text fontSize={'14px'} mt={'1em'}>
              Se precisar de ajuda, não hesite em entrar em contato com nosso suporte.
            </Text>
            <Text fontSize={'14px'} mt={'1em'}>
              Obrigado pela compreensão!
            </Text>
            <HStack alignItems={'center'} mt={'1em'}>
              <WhatsappIcon size={42} round />
              <Text fontWeight={'bold'}>0800 280-2133</Text>
            </HStack>

            <Center mt={'1em'} mb="1em">
              <Button w={'100%'} bg={'#5AB2AE'} color={'white'} borderRadius={'0.8em'} onClick={() => disclosure.onClose()}>
                Entendi
              </Button>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ModalRestricaoSexo;
